import styles from "../app.module.scss";
import { Link } from "react-router-dom";

const MenuItem = ({ to, text }: { to: string; text: string }) => {
  return (
    <span className={styles.topbarMenuItem}>
      <Link to={to} className={styles.tmbLink}>
        {text}
      </Link>
    </span>
  );
};

const MenuBar = () => {
  return (
    <div className={styles.topMenuBar}>
      <MenuItem to="/" text="Startsida" />
      <MenuItem to="/info" text="Information" />
      <MenuItem to="/fixa-tak" text="Fixa tak?" />
      <MenuItem to="/tv" text="TV" />
      <MenuItem to="/avgifter" text="Avgifter" />
      <MenuItem to="/möte" text="Kallelser och Protokoll" />
      <MenuItem to="/ny-hos-oss" text="Ny hos oss?" />
      <MenuItem to="/kontakt" text="Kontakt" />
    </div>
  );
};

export const HeaderBar = () => {
  return (
    <>
      <div className={styles.topTitleBar}>
        Torparängens Samfällighet
        <div className={styles.ttbSmall}>i Vinsta, Stockholm</div>
      </div>
      <MenuBar />
    </>
  );
};
